/**
 * Shower water test advertorial behaviour.
 * Ports the original progress bar, article drawer, water test,
 * UTM passthrough, scroll tracking, video carousel, and accordion.
 */
(function () {
  if (window.__swtAdvertorialInit) {
    return;
  }

  window.__swtAdvertorialInit = true;

  var reducedQuery = "(prefers-reduced-motion: reduce)";

  function rootQuery(selector) {
    return document.querySelector(".swt " + selector);
  }

  function rootQueryAll(selector) {
    return document.querySelectorAll(".swt " + selector);
  }

  function prefersReducedMotion() {
    return window.matchMedia(reducedQuery).matches;
  }

  /**
   * Scrolls to an in-page hash. The page scroller is the document, not `.swt`,
   * so CSS `scroll-behavior` on the section does not apply.
   */
  function scrollToHash(href) {
    if (!href || href.charAt(0) !== "#") {
      return false;
    }

    var target = document.querySelector(href);

    if (!target || !target.scrollIntoView) {
      return false;
    }

    target.scrollIntoView({
      behavior: prefersReducedMotion() ? "auto" : "smooth",
      block: "start",
    });

    return true;
  }

  function initProgressAndMobileBar() {
    var progress = rootQuery(".progress");
    var mobileBuy = rootQuery(".mobile-buy");
    var callsToAction = rootQueryAll(".button[data-cta]");
    var callToActionVisible = false;

    if (!progress && !mobileBuy) {
      return;
    }

    function updateBar() {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      var progressWidth = scrollable > 0
        ? (window.scrollY / scrollable) * 100
        : 0;

      if (progress) {
        progress.style.width = progressWidth + "%";
      }

      if (!mobileBuy) {
        return;
      }

      var showBar = window.scrollY > window.innerHeight * 0.9
        && window.scrollY < document.documentElement.scrollHeight - window.innerHeight * 1.1
        && !callToActionVisible;

      mobileBuy.classList.toggle("show", showBar);
    }

    if ("IntersectionObserver" in window && callsToAction.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.__ctaVisible = entry.isIntersecting;
        });

        callToActionVisible = Array.prototype.some.call(
          callsToAction,
          function (element) {
            return element.__ctaVisible;
          }
        );
        updateBar();
      }, { threshold: 0.15 });

      callsToAction.forEach(function (element) {
        observer.observe(element);
      });
    }

    window.addEventListener("scroll", updateBar, { passive: true });
    updateBar();
  }

  function initCallTracking() {
    rootQueryAll("[data-cta]").forEach(function (link) {
      link.addEventListener("click", function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "advertorial_cta_click",
            placement: link.dataset.cta,
            template: "water2skin-shower-water-test-v3",
          });
        } catch (error) {
          return error;
        }

        return undefined;
      });
    });
  }

  function initDrawer() {
    var shell = document.querySelector("[data-swt-shell]");
    var trigger = rootQuery(".header-pill");
    var drawer = rootQuery(".article-nav-drawer");
    var backdrop = rootQuery(".article-nav-backdrop");
    var closeButton = rootQuery(".article-nav-close");
    var nav = rootQuery(".article-nav-links");

    if (!shell || !trigger || !drawer || !backdrop || !closeButton || !nav) {
      return;
    }

    var lastFocus = null;

    function focusableItems() {
      return Array.from(drawer.querySelectorAll("a,button:not([disabled])"));
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      shell.classList.add("drawer-open");
      trigger.setAttribute("aria-expanded", "true");
      drawer.setAttribute("aria-hidden", "false");
      backdrop.setAttribute("aria-hidden", "false");

      function focusClose() {
        closeButton.focus({ preventScroll: true });
      }

      window.requestAnimationFrame(function () {
        focusClose();
        window.requestAnimationFrame(focusClose);
      });
      window.setTimeout(focusClose, 250);
    }

    function closeDrawer() {
      shell.classList.remove("drawer-open");
      trigger.setAttribute("aria-expanded", "false");
      drawer.setAttribute("aria-hidden", "true");
      backdrop.setAttribute("aria-hidden", "true");
      (lastFocus || trigger).focus({ preventScroll: true });
    }

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      openDrawer();
    });
    closeButton.addEventListener("click", closeDrawer);
    backdrop.addEventListener("click", closeDrawer);
    nav.addEventListener("click", function (event) {
      var link = event.target.closest("a");

      if (!link) {
        return;
      }

      event.preventDefault();
      closeDrawer();
      scrollToHash(link.getAttribute("href"));
      window.history.replaceState(null, "", link.getAttribute("href"));
    });

    document.addEventListener("keydown", function (event) {
      if (!shell.classList.contains("drawer-open")) {
        return;
      }

      if (event.key === "Escape") {
        closeDrawer();
        return;
      }

      if (event.key !== "Tab") {
        return;
      }

      var items = focusableItems();

      if (!items.length) {
        return;
      }

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initCommentForm() {
    var form = rootQuery(".comment-form");

    if (!form) {
      return;
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (!form.reportValidity()) {
        return;
      }

      var title = form.getAttribute("data-success-title") || "Comment submitted";
      var message = form.getAttribute("data-success-body")
        || "Thanks for joining the discussion. Your comment has been received.";
      var success = document.createElement("div");
      var icon = document.createElement("span");
      var copy = document.createElement("div");
      var heading = document.createElement("strong");
      var paragraph = document.createElement("p");
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");

      success.className = "comment-success";
      success.setAttribute("role", "status");
      icon.className = "comment-success-icon";
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("viewBox", "0 0 24 24");
      path.setAttribute("d", "m5 12 4 4L19 6");
      path.setAttribute("fill", "none");
      path.setAttribute("stroke", "currentColor");
      path.setAttribute("stroke-width", "2.5");
      path.setAttribute("stroke-linecap", "round");
      path.setAttribute("stroke-linejoin", "round");
      heading.textContent = title;
      paragraph.textContent = message;
      svg.appendChild(path);
      icon.appendChild(svg);
      copy.appendChild(heading);
      copy.appendChild(paragraph);
      success.appendChild(icon);
      success.appendChild(copy);
      form.replaceChildren(success);
    });
  }

  function initMobileOrder() {
    var body = rootQuery(".article-body");

    if (!body) {
      return;
    }

    var items = Array.prototype.slice.call(body.children).filter(function (element) {
      return element.hasAttribute("data-original-order")
        && element.hasAttribute("data-mobile-order");
    });

    if (!items.length) {
      return;
    }

    var media = window.matchMedia("(max-width:700px)");

    function applyOrder() {
      var attribute = media.matches ? "data-mobile-order" : "data-original-order";

      items.slice().sort(function (first, second) {
        return Number(first.getAttribute(attribute)) - Number(second.getAttribute(attribute));
      }).forEach(function (element) {
        body.appendChild(element);
      });
    }

    if (media.addEventListener) {
      media.addEventListener("change", applyOrder);
    } else {
      media.addListener(applyOrder);
    }

    applyOrder();
  }

  function initWaterTest() {
    var root = document.querySelector("[data-water-test]");

    if (!root) {
      return;
    }

    var buttons = Array.from(root.querySelectorAll(".test-option"));
    var result = root.querySelector(".test-result");

    if (!result) {
      return;
    }

    var oneLabel = root.getAttribute("data-result-one") || "1 sign sounds familiar";
    var manyLabel = root.getAttribute("data-result-many") || "[count] signs sound familiar";
    var lowNote = root.getAttribute("data-note-low")
      || "One or two signs are enough to put your shower environment on the checklist. Your products may not be the only variable worth reviewing.";
    var highNote = root.getAttribute("data-note-high")
      || "Several signs overlap. Your shower water is worth checking alongside the products in your routine.";

    function update() {
      var count = buttons.filter(function (button) {
        return button.getAttribute("aria-pressed") === "true";
      }).length;
      var strong = result.querySelector("strong");
      var note = result.querySelector("span");

      result.dataset.visible = count > 0 ? "true" : "false";
      result.dataset.level = count < 3 ? "watch" : "strong";
      result.setAttribute("aria-hidden", count > 0 ? "false" : "true");

      if (strong) {
        strong.textContent = count === 1
          ? oneLabel
          : manyLabel.replace("[count]", String(count));
      }

      if (note) {
        note.textContent = count < 3 ? lowNote : highNote;
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var pressed = button.getAttribute("aria-pressed") === "true";
        button.setAttribute("aria-pressed", pressed ? "false" : "true");
        update();
      });
    });

    update();
  }

  function initTracking() {
    var article = document.querySelector("[data-swt-article]");
    var productBase = (article && article.getAttribute("data-product-url"))
      || "https://water2.com/pages/w2s-01";
    var incoming = new URLSearchParams(window.location.search);
    var template = "water2skin-shower-water-test-v3";
    var fired = {};

    var skippedParams = {
      k: true,
      tqcontent: true,
      tqpreview: true,
      view: true,
      preview_theme_id: true,
    };

    document.querySelectorAll('a[href^="' + productBase + '"]').forEach(function (link) {
      var target = new URL(link.href);

      incoming.forEach(function (value, key) {
        if (!skippedParams[key]) {
          target.searchParams.append(key, value);
        }
      });

      link.href = target.href;
    });

    function emit(eventName, data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign(
        { event: eventName, template: template },
        data || {}
      ));
    }

    function trackScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var depth = max > 0 ? Math.round((window.scrollY / max) * 100) : 100;

      [25, 50, 75, 100].forEach(function (mark) {
        if (depth >= mark && !fired[mark]) {
          fired[mark] = true;
          emit("advertorial_scroll_depth", { depth: mark });
        }
      });
    }

    window.addEventListener("scroll", trackScroll, { passive: true });
    trackScroll();

    var reveal = document.getElementById("product-reveal");
    var mobile = rootQuery(".mobile-buy");

    function setStickyState() {
      if (!reveal || !mobile) {
        return;
      }

      var reached = window.scrollY + window.innerHeight >= reveal.offsetTop;
      mobile.dataset.revealReached = reached ? "true" : "false";
      mobile.setAttribute("aria-hidden", reached ? "false" : "true");

      if (!reached) {
        mobile.classList.remove("show");
      }

      if (reached && !fired.reveal) {
        fired.reveal = true;
        emit("advertorial_product_reveal", { section: "product-reveal" });
      }
    }

    window.addEventListener("scroll", setStickyState, { passive: true });
    window.addEventListener("resize", setStickyState);
    setStickyState();

    if (reveal && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !fired.reveal) {
            fired.reveal = true;
            emit("advertorial_product_reveal", { section: "product-reveal" });
          }
        });
      }, { threshold: 0.25 }).observe(reveal);
    }
  }

  function initCarousel() {
    var gallery = document.querySelector("#w2-ugc-carousel");
    var controls = rootQuery(".w2-ugc-controls");

    if (!gallery || !controls) {
      return;
    }

    var buttons = controls.querySelectorAll("button");
    var label = controls.querySelector("span");
    var startLabel = controls.getAttribute("data-label-start") || "Videos 1–2 of 3";
    var endLabel = controls.getAttribute("data-label-end") || "Videos 2–3 of 3";

    function update() {
      var max = gallery.scrollWidth - gallery.clientWidth;

      if (buttons[0]) {
        buttons[0].disabled = gallery.scrollLeft < 2;
      }

      if (buttons[1]) {
        buttons[1].disabled = gallery.scrollLeft >= max - 2;
      }

      if (label) {
        label.textContent = gallery.scrollLeft > max / 2 ? endLabel : startLabel;
      }
    }

    buttons.forEach(function (button, index) {
      button.addEventListener("click", function () {
        gallery.scrollTo({
          left: index ? gallery.scrollWidth : 0,
          behavior: prefersReducedMotion() ? "auto" : "smooth",
        });
      });
    });

    gallery.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    gallery.addEventListener("keydown", function (event) {
      if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
        event.preventDefault();
        buttons[event.key === "ArrowRight" ? 1 : 0].click();
      }
    });
    update();
  }

  function initJumpLink() {
    rootQueryAll(".article-jump-cta").forEach(function (link) {
      link.addEventListener("click", function (event) {
        var href = link.getAttribute("href");

        if (!scrollToHash(href)) {
          return;
        }

        event.preventDefault();
        window.history.replaceState(null, "", href);
      });
    });
  }

  function initAccordion() {
    rootQueryAll(".w2-accordion-toggle").forEach(function (button) {
      var answer = document.getElementById(button.getAttribute("aria-controls"));

      if (!answer) {
        return;
      }

      button.setAttribute("aria-expanded", "false");
      answer.hidden = true;
      button.addEventListener("click", function () {
        var open = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!open));
        answer.hidden = open;
      });
    });
  }

  function boot() {
    initProgressAndMobileBar();
    initCallTracking();
    initJumpLink();
    initDrawer();
    initCommentForm();
    initMobileOrder();
    initWaterTest();
    initTracking();
    initCarousel();
    initAccordion();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
